/* eslint-disable @angular-eslint/directive-selector */

import { Directive, TemplateRef } from '@angular/core'

@Directive({
    selector: '[expansionPanelHeader]',
    standalone: false,
})
export class ExpansionPanelHeaderDirective {
    constructor(public templateRef: TemplateRef<any>) {}
}
